import { useLayoutEffect } from 'react';

export const useRobotNoIndex = () => {
  useLayoutEffect(() => {
    // get the robots meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    // if there was no robots meta tag, add one
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    // tell Googlebot to exclude this page from the index
    metaRobots.setAttribute('content', 'noindex');

    // clean up
    return () => {
      metaRobots?.setAttribute('content', 'all');
    };
  });
};
